import React, { Component } from 'react'
import styled from 'styled-components'

import IconWeatherBrokenClouds from '../../assets/icons/weather/broken-clouds.svg'
import IconWeatherClearSky from '../../assets/icons/weather/clear-sky.svg'
import IconWeatherClearSkyNight from '../../assets/icons/weather/clear-sky-night.svg'
import IconWeatherFewClouds from '../../assets/icons/weather/few-clouds.svg'
import IconWeatherFewCloudsNight from '../../assets/icons/weather/few-clouds-night.svg'
import IconWeatherMist from '../../assets/icons/weather/mist.svg'
import IconWeatherRain from '../../assets/icons/weather/rain.svg'
import IconWeatherScatteredClouds from '../../assets/icons/weather/scattered-clouds.svg'
import IconWeatherShowerRain from '../../assets/icons/weather/shower-rain.svg'
import IconWeatherSnow from '../../assets/icons/weather/snow.svg'
import IconWeatherThunderstorm from '../../assets/icons/weather/thunderstorm.svg'

const WeatherStyle = styled.div`
  display: inline-flex;
  align-items: center;

  img {
    height: 28px;
    margin-right: 10px;
  }

  h5 {
    font-size: 1em;
    color: #0A0A0A;
  }
`;

export default class Weather extends Component {
  state = {
    temperature: 0,
    weatherIcon: undefined
  }

  UNSAFE_componentWillMount = () => {
    const weatherData = 'https://api.openweathermap.org/data/2.5/weather?q=Ozzero&lang=it&units=metric&appid=70003b2eacdf1ce17952649a64f80c81';

    const hours = new Date().getHours()
    let isDayTime = hours > 6 && hours < 20

    if (typeof window !== `undefined` && navigator.onLine) {
      window.fetch(weatherData)
      .then(data =>{return data.json()})
      .then(res =>{
        this.setState({
          temperature: Math.round(res.main.temp)
        })

        if (res.weather[0].id >= 200 && res.weather[0].id <= 232) {
          this.setState({
            weatherIcon: `${IconWeatherThunderstorm}`
          })
        }

        if (res.weather[0].id >= 300 && res.weather[0].id <= 321) {
          this.setState({
            weatherIcon: `${IconWeatherShowerRain}`
          })
        }

        if (res.weather[0].id >= 500 && res.weather[0].id <= 504) {
          this.setState({
            weatherIcon: `${IconWeatherRain}`
          })
        }

        if (res.weather[0].id === 511) {
          this.setState({
            weatherIcon: `${IconWeatherSnow}`
          })
        }

        if (res.weather[0].id >= 520 && res.weather[0].id <= 531) {
          this.setState({
            weatherIcon: `${IconWeatherShowerRain}`
          })
        }

        if (res.weather[0].id >= 600 && res.weather[0].id <= 522) {
          this.setState({
            weatherIcon: `${IconWeatherSnow}`
          })
        }

        if (res.weather[0].id >= 701 && res.weather[0].id <= 781) {
          this.setState({
            weatherIcon: `${IconWeatherMist}`
          })
        }

        if (res.weather[0].id === 800 && isDayTime) {
          this.setState({
            weatherIcon: `${IconWeatherClearSky}`
          })
        }

        if (res.weather[0].id === 800 && !isDayTime) {
          this.setState({
            weatherIcon: `${IconWeatherClearSkyNight}`
          })
        }

        if (res.weather[0].id === 801 && isDayTime) {
          this.setState({
            weatherIcon: `${IconWeatherFewClouds}`
          })
        }

        if (res.weather[0].id === 801 && !isDayTime) {
          this.setState({
            weatherIcon: `${IconWeatherFewCloudsNight}`
          })
        }
        
        if (res.weather[0].id === 802) {
          this.setState({
            weatherIcon: `${IconWeatherScatteredClouds}`
          })
        }

        if (res.weather[0].id >= 803 && res.weather[0].id <= 804) {
          this.setState({
            weatherIcon: `${IconWeatherBrokenClouds}`
          })
        }

      })
    }
  }
  
  render() {
    return (
      <WeatherStyle>
        <img src={this.state.weatherIcon} alt=""/>
        <h5>{this.state.temperature === 0 ? '' : this.state.temperature + '° C'}</h5>
      </WeatherStyle>
    )
  }
}
